import { useEffect, useState } from "react";
import Table from "react-bootstrap/esm/Table";
import axios from "axios";
export default function CreditNotes() {
  const [creditNotes, setCreditNotes] = useState([]);
  const [isLoading, setisLoading] = useState(true);

  const getCreditNotes = async () => {
    let url = "/api/CreditNotes";
    await axios
      .get(url)
      .then((result) => {
        setCreditNotes(result.data.creditNotes);
        let laodingState = false;
        setisLoading(laodingState);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setisLoading(false);
      });
  };
  useEffect(() => {
    console.log(creditNotes)
    getCreditNotes();
  }, [isLoading]);
  return (
    <Table>
      <thead>
        <tr>
          <th>Credit Note No</th>
          <th>Customer Invoice Id</th>
          <th>Client Name</th>
          <th>Currency</th>
          <th>Total</th>
          <th>Value Date</th>
        </tr>
      </thead>
      <tbody>
     
        {creditNotes &&
          creditNotes.length>0 ? creditNotes.map((creditNote) => (
            <tr key={creditNote.id}>
              <td>{creditNote.creditNoteNo ?? '-'}</td>
              <td>{creditNote.customerInvoiceId ?? '-'}</td>
              <td>{creditNote.customerName}</td>
              <td>{creditNote.currency}</td>
              <td>{creditNote.total}</td>
              <td>{creditNote.valueDate ?? '-'} </td>
            </tr>
          )) : 'No data available'}
      </tbody>
    </Table>
  );
}
